import { api } from './api';
import type {
  ProjectListResponse,
  ProjectResponse,
  ApiKeyListResponse,
  ApiKeyResponse,
  DeleteProjectResponse,
  RevokeApiKeyResponse,
  CreateProjectRequest,
  UpdateProjectRequest,
  CreateApiKeyRequest,
} from '../types/project';

// Project endpoints
export const projectsApi = {
  list: (organizationId: string) =>
    api.get<ProjectListResponse>(`/api/organizations/${organizationId}/projects`),

  get: (projectId: string) =>
    api.get<ProjectResponse>(`/api/projects/${projectId}`),

  create: (organizationId: string, data: CreateProjectRequest) =>
    api.post<ProjectResponse>(`/api/organizations/${organizationId}/projects`, data),

  update: (projectId: string, data: UpdateProjectRequest) =>
    api.put<ProjectResponse>(`/api/projects/${projectId}`, data),

  delete: (projectId: string) =>
    api.delete<DeleteProjectResponse>(`/api/projects/${projectId}`),
};

// API Keys endpoints
export const apiKeysApi = {
  list: (projectId: string) =>
    api.get<ApiKeyListResponse>(`/api/projects/${projectId}/api-keys`),

  create: (projectId: string, data: CreateApiKeyRequest) =>
    api.post<ApiKeyResponse>(`/api/projects/${projectId}/api-keys`, data),

  revoke: (projectId: string, keyId: string) =>
    api.delete<RevokeApiKeyResponse>(`/api/projects/${projectId}/api-keys/${keyId}`),
};
